import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative h-full"
}
const _hoisted_2 = { class: "py-1" }
const _hoisted_3 = {
  style: {"grid-template-columns":"2em auto 1.5em"},
  class: "w-full grid items-center gap-2"
}
const _hoisted_4 = { class: "grid content-center" }
const _hoisted_5 = { class: "text-gray-800" }
const _hoisted_6 = { class: "justify-end grid" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  style: {"grid-template-columns":"2em auto"},
  class: "grid gap-2 items-center"
}
const _hoisted_10 = { class: "grid content-center" }
const _hoisted_11 = { class: "text-gray-800" }
const _hoisted_12 = {
  style: {"grid-template-columns":"2em auto"},
  class: "w-full grid items-center gap-2"
}
const _hoisted_13 = { class: "grid content-center" }
const _hoisted_14 = { class: "text-gray-800" }
const _hoisted_15 = { class: "w-full flex space-x-2 items-center" }
const _hoisted_16 = { class: "font-semibold text-lg" }
const _hoisted_17 = {
  class: "hidden",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ExpandIcon = _resolveComponent("ExpandIcon")!
  const _component_ActionModal = _resolveComponent("ActionModal")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_UpdateKeyFigures = _resolveComponent("UpdateKeyFigures")!

  return (_ctx.hasActiveDirectory && !_ctx.hasRealtimeOnlyModule)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_DropDown, {
          expand: _ctx.expandDropdown,
          "onUpdate:expand": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.expandDropdown) = $event)),
          "dropdown-class": "mt-2 w-60"
        }, {
          "dropdown-content": _withCtx(() => [
            _createVNode(_component_ActionModal, {
              "initial-step-index": 0,
              "initial-state": _ctx.actionModalInitialState
            }, {
              default: _withCtx(({ open }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-left w-full px-6 py-3 hover:bg-gray-100 font-medium cursor-pointer first:rounded-t-md",
                    role: "menuitem",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.batchExpanded = !_ctx.batchExpanded)),
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.expandDropdown = false), ["esc"]))
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_Icon, { src: _ctx.batchIcon }, null, 8, ["src"])
                      ]),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('layouts.dashboard.topBar.batchButton.label')), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_ExpandIcon, {
                          color: "black",
                          expand: _ctx.batchExpanded
                        }, null, 8, ["expand"])
                      ])
                    ])
                  ], 32),
                  (_ctx.batchExpanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchEvents, (event) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: event.id,
                            type: "button",
                            class: "text-left w-full pl-10 pr-6 py-2 hover:bg-gray-100 cursor-pointer",
                            role: "menuitem",
                            onClick: ($event: any) => (_ctx.onBatchEventClicked(event, open)),
                            onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.expandDropdown = false), ["esc"]))
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_Icon, {
                                  src: event.icon_url
                                }, null, 8, ["src"])
                              ]),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(event.name), 1)
                            ])
                          ], 40, _hoisted_8))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-left w-full px-6 py-3 hover:bg-gray-100 font-medium cursor-pointer last:rounded-b-md",
                    role: "menuitem",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onRecalculateClicked && _ctx.onRecalculateClicked(...args))),
                    onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.expandDropdown = false), ["esc"]))
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_Icon, {
                          src: _ctx.recalculateIcon,
                          class: "grayscale"
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('layouts.dashboard.topBar.updateKeyFigures.buttonLabel')), 1)
                    ])
                  ], 32)
                ])
              ]),
              _: 1
            }, 8, ["initial-state"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "bg-primary-800 border-primary-700 border hover:bg-primary-700 transition-colors rounded-xl py-2 px-4 text-white cursor-pointer h-full",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.expandDropdown = !_ctx.expandDropdown))
            }, [
              _createElementVNode("span", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('layouts.dashboard.topBar.actionsMenu.label')), 1),
                _createVNode(_component_ExpandIcon, {
                  color: "white",
                  expand: _ctx.expandDropdown
                }, null, 8, ["expand"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["expand"]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_UpdateKeyFigures, { ref: "updateKeyFigures" }, null, 512)
        ])
      ]))
    : _createCommentVNode("", true)
}